import React, { createContext, useContext, useState } from 'react';
import translations from '../lib/i18n';

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem('laiow_lang') || 'en');

  const toggleLang = () => {
    const newLang = lang === 'en' ? 'hi' : 'en';
    setLang(newLang);
    localStorage.setItem('laiow_lang', newLang);
  };

  const t = (key) => translations[lang]?.[key] || translations.en?.[key] || key;

  return (
    <LangContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
